module.exports = __webpack_public_path__ + "img/rick_morty_codesandbox.6ba245d7.png";